import { Action, createReducer, on } from '@ngrx/store';

import * as FieldsActions from './actions';
import { FieldsState } from '../models/fields.models';

const reducer = createReducer<FieldsState>(
  {},
  on(FieldsActions.loadCropFieldsSuccess, (state, { cropFields }) => ({
    ...state,
    cropFields,
  })),
  on(FieldsActions.getManureSpaceSettingsSuccess, (state, { settings }) => ({
    ...state,
    settings,
  })),
  on(FieldsActions.getManureSpaceSettingTogglesSuccess, (state, { settingToggles }) => ({
    ...state,
    settingToggles,
  })),
);

export const fieldsReducer = (state: FieldsState | undefined, action: Action) =>
  reducer(state, action);
